import { auditAction } from "../actions/types";

const defaultState = [];
export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case auditAction.FECTCH_AUDITS: // fet all the investigations by selected record ID
      return { ...state, audits: action.payload };
    default:
      return state;
  }
}
